import { Box, Stack, styled, Typography } from '@mui/material';
import { ReactNode } from 'react';

import AsideSectionHeader from '../AsideSectionHeader';
import ContentCard from '../ContentCard';

export default function ActivitiesMock() {
    return (
        <ContentCard>
            <Stack flexDirection="row"
                justifyContent="space-between"
            >
                <AsideSectionHeader title="Recent activity" />

                <Typography variant="caption"
                    sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                    fontWeight="medium">
                    View all
                </Typography>
            </Stack>

            <Stack gap={ 2 }
                pt={ 3 }>
                <ActivityLine title="<b>2 new matches</b> in Stockholm"
                    subtitle="3m ago · filters: React, TS"
                    important
                />
                <ActivityLine title="Application sent for the position of Software Engineer at TechCorp."
                    subtitle="1h ago"
                />
                <ActivityLine title="Profile updated"
                    subtitle="Yesterday"
                />
            </Stack>
        </ContentCard>
    );
}

interface ActivityLineProps {
    title: ReactNode;
    subtitle: string;
    important?: boolean;
}

function ActivityLine({ title, subtitle, important }: ActivityLineProps) {
    return (
        <ActivityLineRoot important={ important }>
            <Typography variant="caption"
                fontWeight="medium"
                color="textTertiary"
            >
                <Box dangerouslySetInnerHTML={{ __html: String(title) }} />
            </Typography>
            <Typography variant="caption"
                color="textSecondary">
                { subtitle }
            </Typography>
        </ActivityLineRoot>
    );
}

const ActivityLineRoot = styled(Stack,
    { shouldForwardProp: (prop) => prop !== 'important' }
)<{ important?: boolean }>(({ theme, important }) => ({
    position: 'relative',
    paddingLeft: theme.spacing(4),
    minHeight: 20,
    marginLeft: theme.spacing(1),
    paddingBottom: theme.spacing(2),
    '&:before': {
        content: '""',
        position: 'absolute',
        left: -3,
        top: 7,
        width: 6,
        height: 6,
        borderRadius: '50%',
        background: important ? theme.palette.primary.main : theme.palette.divider
    },
    '&:after': {
        content: '""',
        position: 'absolute',
        left: -1,
        top: 20,
        bottom: 0,
        borderLeft: `1px solid ${ theme.palette.divider }`
    }
}));
